import { FC } from "react";
import { Text } from "@chakra-ui/react";
import {
  CONSUMER_HEALTH_PRIVACY_NOTICE_URL,
  PRIVACY_POLICY_URL,
  sharedProps,
} from "~/constants";
import { Checkbox } from "~/OnboardingApp/components";
import { trackEmail as track } from "~/OnboardingApp/events";
import { Trans } from "~/utils/i18next";

const components = {
  PrivacyPolicyLink: (
    <Text
      as="a"
      color="inherit"
      href={PRIVACY_POLICY_URL}
      onClick={track.privacyLink}
      px={0}
      target="_blank"
      {...sharedProps.link.hover}
    />
  ),
  CHPNotice: (
    <Text
      as="a"
      color="inherit"
      href={CONSUMER_HEALTH_PRIVACY_NOTICE_URL}
      onClick={track.consumerHealthPrivacyNotice}
      px={0}
      target="_blank"
      {...sharedProps.link.hover}
    />
  ),
};

export const AdditionalTermsCheckbox: FC = () => {
  return (
    <Checkbox name="acceptedAdditionalTerms">
      <Text color="th.gray4" variant="small-print">
        <Trans
          components={components}
          i18nKey="onboarding.emailPage.acceptedAdditionalTerms"
        />
      </Text>
    </Checkbox>
  );
};
